module.exports = __webpack_public_path__ + "src/img/down.769702a8.svg";